$(document).ready(function () {
    // Инициализиране на tomselect като го търсим по клас. maxOptions сега слага, тъй като по подразбиране е 50, а в някой от списъците има повече
    $(".form-tom-select").each(function () {
        let tomSelectInstance = new TomSelect(this, {
            maxOptions: null
        });

        //Добавяне на onchange евент само за списък с Регистри
        if ($(this).attr("id") === "registers") {
            tomSelectInstance.on("change", function () {
                disableSelects();
            });
        }
    });

    // Инициализация на bootstrap тултип
    $('[data-bs-toggle="tooltip"]').each(function () {
        return new bootstrap.Tooltip(this);
    });

    //Submit на бутон Търси
    $("#submitSearch").on("click", function () {
        setRegistryTypeFromActiveLink();
        $("#searchForm").submit();
    });

    // Закачане към event при натискане на линкове с тип регистър над резултатите от търсене - типът регистър го записваме в hidden input
    $(".register-link").on("click", function (event) {
        event.preventDefault();
        let registryType = $(this).data("registrytype");
        let selectedRegister = $("#registers").val();
        if (selectedRegister) {
            clearSelect('registers');
        }
        $("#SelectedRegistryTypeFromLink").val(registryType);
        $("#searchForm").submit(); // Submit the form
    });

    //Закачане към евент при натискане на Pagination линкове - при натискане да submit-ва формата
    $(".page-link").on("click", function (event) {
        event.preventDefault();

        // Не правим заявка към сървъра, ако към елемента няма data-page атрибут
        if (!$(this).data("page")) {
            return;
        }

        setRegistryTypeFromActiveLink();
        $("#Page").val($(this).data("page"));
        $("#searchForm").submit();
    });

    // Ако има визуализирани резултати на екрана при зареждане на страницата, скролваме към тях.
    if (!$(".results-container").hasClass('d-none')) {
        $(".results-container")[0].scrollIntoView();
    }
});

//Ако имаме избран (active) линк от тип регистър над резултатите, да го вземем и запишем в hidden input
function setRegistryTypeFromActiveLink() {
    let navLink = $(".register-link.active").first();
    let hiddenInput = $("#SelectedRegistryTypeFromLink");
    let selectedRegister = $("#registers").val();

    if (selectedRegister) {
        hiddenInput.val('');
        return;
    }

    if (navLink.length) {
        hiddenInput.val(navLink.data("registrytype"));
    }
}

// Премахва избраните стойности в падащия списък
function clearSelect(id) {
    let select = $('#' + id);
    let control = select[0].tomselect;
    if (!control) {
        return;
    }
    control.clear(true);
}
// Заключва падащите списъци с Езици и Области на правото
function disableSelects() {
    let selectedRegisterSelect = $("#registers").val();
    let languagesSelect = $("#languages");
    let areasOfExpertiseSelect = $("#areasOfExpertise");
    let languageControl = languagesSelect[0].tomselect;
    let areaOfExpertiseControl = areasOfExpertiseSelect[0].tomselect;

    if (!languageControl || !areaOfExpertiseControl) {
        return;
    }

    if (selectedRegisterSelect === "LawFirms" || selectedRegisterSelect === "LawyerPartnerships" || selectedRegisterSelect === "AttorneyAssistants") {
        languageControl.disable();
        areaOfExpertiseControl.disable();
    }
    else {
        languageControl.enable();
        areaOfExpertiseControl.enable();
    }
}